export const DEBUG_INFO_OPEN_EVENT = "debug-info:open"

export function dispatchOpenDebugInfo() {
  window.dispatchEvent(new CustomEvent(DEBUG_INFO_OPEN_EVENT))
}
